import React, { useEffect, Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { RootState } from '@Redux/detail/store';
import { StickyHeader } from '@components/DetailPage';
import { createSearchPanel } from '@utils/createSearchPanel';
import { I_Group } from '@Redux/detail/Group/interfaces';
import styles from './styles.module.scss';

interface I_Route {
    href: string | undefined;
    text: string;
    spliter?: string;
}

interface I_Props {
    pageType?: 'search' | 'detail';
    routes?: I_Route[];
    travelType?: any;
}

function CallSearchElement({ routes, travelType }: I_Props) {
    const [isScroll, setIsScroll] = useState(false);

    useScrollPosition(({ currPos }) => {
        const isSrollPage = -currPos.y > 50;
        isSrollPage ? setIsScroll(true) : setIsScroll(false);
    });

    return (
        <div className={`${styles.fixedFiller} ${travelType === '2' ? styles.GroupFree : ''}`}>
            <div className={`${styles.topElement} ${isScroll ? styles.fixedTopElement : ''}`}>
                <div
                    className={`${styles.searchPanel_wrapper} ${
                        isScroll ? styles.fixWrapperPC : ''
                    }`}
                >
                    <div className={styles.searchBlock}>
                        <div className={styles.breadCrumb}>
                            {routes?.map((anchor: I_Route, i: number) => (
                                <span
                                    className={`${styles.anchor} ${isScroll ? 'd-no' : ''}`}
                                    key={i}
                                >
                                    {i !== 0 && (anchor.spliter || ` > `)}
                                    {anchor.href ? (
                                        <a className={styles.anchorText} href={anchor.href}>
                                            {anchor.text}
                                        </a>
                                    ) : (
                                        <span className={styles.anchorText}>{anchor.text}</span>
                                    )}
                                </span>
                            ))}
                        </div>
                        <div
                            id="SearchPanel"
                            className={`${
                                travelType === '2'
                                    ? styles.GroupFreeSearchPC // 團體自由行引擎
                                    : styles.GroupSearchPC // 團體引擎
                            } ${isScroll ? styles.fixedTop : ''}`}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

function CallDetailElement({ routes, travelType }: I_Props) {
    const { isSearchPanelFixed } = useSelector((state: RootState) => state.switcherReducer);
    const { travelinfo } = document.getElementById('detailPagePara')!.dataset!;
    const { GroupInfo }: I_Group = JSON.parse(travelinfo!);

    return (
        <div className={`${styles.fixedFiller} ${travelType === '2' ? styles.GroupFree : ''}`}>
            <div
                className={`${styles.topElement} ${
                    isSearchPanelFixed ? styles.fixedTopElement : ''
                }`}
            >
                <div
                    className={`${styles.searchPanel_wrapper} ${
                        GroupInfo.GroupID && isSearchPanelFixed ? styles.fixWrapperPC : ''
                    }`}
                >
                    <div className={styles.searchBlock}>
                        <div className={styles.breadCrumb}>
                            {routes?.map((anchor: I_Route, i: number) => (
                                <span
                                    className={`${styles.anchor} ${
                                        GroupInfo.GroupID && isSearchPanelFixed ? 'd-no' : ''
                                    }`}
                                    key={i}
                                >
                                    {i !== 0 && (anchor.spliter || ` > `)}
                                    {anchor.href ? (
                                        <a className={styles.anchorText} href={anchor.href}>
                                            {anchor.text}
                                        </a>
                                    ) : (
                                        <span className={styles.anchorText}>{anchor.text}</span>
                                    )}
                                </span>
                            ))}
                        </div>
                        <div
                            id="SearchPanel"
                            className={`${
                                GroupInfo.GroupID
                                    ? travelType === '2'
                                        ? styles.GroupFreeSearchPC // 團體自由行引擎
                                        : styles.GroupSearchPC // 團體引擎
                                    : ''
                            } ${GroupInfo.GroupID && isSearchPanelFixed ? styles.fixedTop : ''}`}
                        />
                    </div>
                </div>
                {GroupInfo.GroupID && isSearchPanelFixed && <StickyHeader />}
            </div>
        </div>
    );
}

const SearchPanelBlock: React.FC<I_Props> = ({ pageType, routes, travelType }) => {
    useEffect(() => {
        createSearchPanel({ device: 'PC', travelType });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return pageType === 'search' ? (
        <CallSearchElement routes={routes} travelType={travelType} />
    ) : (
        <CallDetailElement routes={routes} travelType={travelType} />
    );
};

export default SearchPanelBlock;
